var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-title',[_c('h3',[_vm._v("Dashboard")])]),_c('v-card-subtitle',[_vm._v("Reports & Analytics Center ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }